import { render, staticRenderFns } from "./ShipRequestDialog.vue?vue&type=template&id=2e9bae4f&scoped=true&"
import script from "./ShipRequestDialog.vue?vue&type=script&lang=js&"
export * from "./ShipRequestDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShipRequestDialog.vue?vue&type=style&index=0&id=2e9bae4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9bae4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDataTable,VRow})
